import { useState, useEffect, forwardRef, useImperativeHandle } from "react";

import "./stylesPaymentsInstrumentsModal.css";

import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";

import { Input, message, Select } from "antd";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import ToggleSwitch from "../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";

const PaymentsInstrumentsModal = forwardRef(({ handleCancel, data }, ref) => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const PAYMENT_MODES = {
    DEPOSIT: "deposit",
    WITHDRAWAL: "withdrawal",
  };

  // state variables
  const [deletingSourceId, setDeletingSourceId] = useState(null);
  const [isFetchApiRunning, setIsFetchApiRunning] = useState(false);
  const [depositBanksList, setDepositBanksList] = useState([]);
  const [withdrawalBanksList, setWithdrawalBanksList] = useState([]);
  const [cardDetails, setCardDetails] = useState([]);

  useImperativeHandle(ref, () => ({
    fetchAllBanksOfAllTypes,
    handleClose,
  }));

  const retrieveUsersPaymentInstruments = async (payment_mode) => {
    const params = {
      user_id: data?.user_id,
      payment_mode: payment_mode,
    };

    try {
      const response = await PrivateAdminPanelInstance?.get(
        API_ROUTES?.GET_PAYMENT_INSTRUMENTS?.replace(
          "{user_id}",
          params.user_id
        )?.replace("{payment_mode}", params.payment_mode),
        params
      );

      if (payment_mode === PAYMENT_MODES?.DEPOSIT) {
        setDepositBanksList(response?.data?.data);
      } else {
        setWithdrawalBanksList(response?.data?.data);
      }
    } catch (error) {
      console.log(
        `Error fetching ${payment_mode} bank accounts`,
        error?.response
      );
    }
  };

  const getCardDetails = async () => {
    if (!data?.user_id) {
      return;
    }

    const params = {
      user_id: data?.user_id,
    };
    try {
      const response = await PrivateAdminPanelInstance.get(
        API_ROUTES.GET_CARD_DETAILS?.replace("{user_id}", params?.user_id),
        params
      );
      const cardData = response?.data?.data;
      console.log("cardDetails", cardData);
      setCardDetails(cardData);
    } catch (error) {
      console.log("error fetching card details", error);
    }
  };

  const deleteSpecificBankAccount = async (
    payment_mode,
    source_id,
    bank_provider
  ) => {
    setDeletingSourceId(source_id);

    const params = {
      user_id: data?.user_id,
      payment_mode: payment_mode,
      source_id: source_id,
    };

    try {
      await PrivateAdminPanelInstance?.delete(
        API_ROUTES?.DELETE_SPECIFIC_PAYMENT_INSTRUMENT?.replace(
          "{user_id}",
          data?.user_id
        )
          ?.replace("{bank_id}", params?.source_id)
          ?.replace("{payment_mode}", params?.payment_mode),
        params
      );

      if (payment_mode === PAYMENT_MODES?.DEPOSIT) {
        retrieveUsersPaymentInstruments(PAYMENT_MODES?.DEPOSIT);
      } else {
        retrieveUsersPaymentInstruments(PAYMENT_MODES?.WITHDRAWAL);
      }
      setDeletingSourceId(null);
    } catch (error) {
      console.log("erorr deleting all banks", error);
      setDeletingSourceId(null);
    }
  };

  const handleDeleteCreditCard = async (cardId) => {
    setIsFetchApiRunning(true);

    const params = {
      user_id: data?.user_id,
      source_id: cardId,
    };


    try {
      await PrivateAdminPanelInstance.delete(
        API_ROUTES.DELETE_CARD_FROM_CARDS_LIST?.replace("{user_id}", params?.user_id)?.replace("{card_id}", params?.source_id),
        params
      );

      const filteredCardDetails = cardDetails.filter(
        (card) => card.source_id !== cardId
      );

      setCardDetails(filteredCardDetails);
      message.success(AppStrings.CARD_DELETED_SUCCESSFULLY);
    } catch (error) {
      console.log("error deleting card", error);
      message.error(AppStrings.ERROR_DELETING_CARD);
    } finally {
      setIsFetchApiRunning(false);
    }
  };

  // helper functions
  const fetchAllBanksOfAllTypes = async () => {
    setIsFetchApiRunning(true);

    try {
      await Promise.all([
        retrieveUsersPaymentInstruments(PAYMENT_MODES?.DEPOSIT),
        retrieveUsersPaymentInstruments(PAYMENT_MODES?.WITHDRAWAL),
        getCardDetails(),
      ]);
    } catch (error) {
      console.log("Error fetching payment instruments", error);
    } finally {
      setIsFetchApiRunning(false);
    }
  };

  const handleSave = () => {
    handleCancel();
  };

  const handleClose = () => {
    setIsFetchApiRunning(false);
    setDeletingSourceId(null);
  };

  return (
    <div className="payment-instruments-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title">
            {" "}
            {AppStrings.EDIT_USER_PAY_INSTRUMENTS}
          </h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="banks-container">
        <div className="bank-header-row">{AppStrings.CREDIT_CARDS}</div>

        {isFetchApiRunning ? (
          <RebetLoader height={"70px"} width={"70p"} />
        ) : (
          <>
            {cardDetails.map((item, index) => (
              <div className="bank-row" key={index}>
                <div>
                  <div className="bank-label">{item?.cc_number}</div>
                  <div className="bank-label" style={{ fontSize: "12px" }}>{item?.card_type}</div>
                </div>
                <div className="bank-label">{item?.card_holder_name}</div>
                <div className="delete-one-bank-button-container">
                  <button
                    className="delete-one-bank-button"
                    onClick={() => handleDeleteCreditCard(item?.source_id)}
                  >
                    {deletingSourceId === item?.source_id ? (
                      <RebetLoader height={"20px"} width={"20px"} />
                    ) : (
                      <DeleteOutlined className="delete-one-bank-button-icon" />
                    )}
                  </button>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      <div className="banks-container">
        <div className="bank-header-row">{AppStrings.DEPOSIT_PAYMENT_OPTIONS}</div>

        {isFetchApiRunning ? (
          <RebetLoader height={"70px"} width={"70p"} />
        ) : (
          <>
            {depositBanksList.map((item, index) => (
              <div className="bank-row" key={index}>
                <div className="bank-label">{item?.bank_provider}</div>

                <div className="delete-one-bank-button-container">
                  <button
                    className="delete-one-bank-button"
                    onClick={() =>
                      deleteSpecificBankAccount(
                        PAYMENT_MODES?.DEPOSIT,
                        item?.source_id,
                        item?.bank_provider
                      )
                    }
                  >
                    {deletingSourceId === item?.source_id ? (
                      <RebetLoader height={"20px"} width={"20px"} />
                    ) : (
                      <DeleteOutlined className="delete-one-bank-button-icon" />
                    )}
                  </button>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      <div className="banks-container">
        <div className="bank-header-row">{AppStrings.WITHDRAWAL_PAYMENT_OPTIONS}</div>

        {isFetchApiRunning ? (
          <RebetLoader height={"70px"} width={"70p"} />
        ) : (
          <>
            {withdrawalBanksList.map((item, index) => (
              <div className="bank-row" key={index}>
                <div className="bank-label">{item?.bank_provider}</div>

                <div className="delete-one-bank-button-container">
                  <button
                    className="delete-one-bank-button"
                    onClick={() =>
                      deleteSpecificBankAccount(
                        PAYMENT_MODES?.WITHDRAWAL,
                        item?.source_id,
                        item?.bank_provider
                      )
                    }
                  >
                    {deletingSourceId === item?.source_id ? (
                      <RebetLoader height={"20px"} width={"20px"} />
                    ) : (
                      <DeleteOutlined className="delete-one-bank-button-icon" />
                    )}
                  </button>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      <div className="modal-footer" style={{ display: "flex", gap: "10px" }}>
        <div
          className="buttons"
          style={{ width: "100%", display: "flex", gap: "10px" }}
        >
          <button className="cancel-button" onClick={handleCancel}>
            {isFetchApiRunning ? (
              <RebetLoader height={"20px"} width={"20px"} />
            ) : (
              AppStrings.CLOSE
            )}
          </button>
          <button className="save-button" onClick={handleSave}>
            {isFetchApiRunning ? (
              <RebetLoader height={"20px"} width={"20px"} />
            ) : (
              AppStrings.SAVE
            )}
          </button>
        </div>
      </div>
    </div>
  );
});

export default PaymentsInstrumentsModal;
